import {React, styled} from 'common'
import {Texts} from 'appearance'
import {setApiError, useApiError} from 'store/Store'
import {useNavigate} from 'react-router-dom'
import Dialog from 'components/Display/Dialog/Dialog'
import {useDispatch} from 'react-redux'

const ApiErrorDialog = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const apiError = useApiError()
    const {title, msg, button, url} = apiError || {}

    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            title={title}
            saveButtonText={button}
            open={apiError}
            handleClose={() => dispatch(setApiError(null))} // setApiError(false)}
            showCancel={false}
            handleSave={() => url && navigate(url)}>
            <Description>{msg}</Description>
        </Dialog>
    )
}

export default ApiErrorDialog

const Description = styled(Texts.RegularText)``
